export default __webpack_public_path__ + "static/blank-3e144fbe20ff322b1cec731f83006523.png";